import { type FloatingPosition, HoverCard } from '@any-ui-react/core';
import type { ReactNode } from 'react';
import { PlainActionMaterialIcon } from '@/common/components/shared/action-material-icon/PlainActionMaterialIcon';
import { MaterialIcons, type MaterialIconsProps } from '../material-icons';

interface Props {
  children: ReactNode;
  customTarget?: ReactNode;
  defaultOpened?: boolean;
  /** When false, renders nothing at all (icon and tooltip both hidden). */
  isTooltipVisible?: boolean;
  /** When true, keeps the icon visible but disables the hover popover. */
  disabled?: boolean;
  materialIconProps?: MaterialIconsProps;
  position?: FloatingPosition;
  onClick?: () => void;
}

export const HoverCardWithIcon = ({
  children,
  customTarget,
  defaultOpened = false,
  isTooltipVisible = true,
  disabled = false,
  materialIconProps,
  position,
  onClick,
}: Props) => {
  if (!isTooltipVisible) {
    return <></>;
  }

  return (
    <HoverCard
      classNames={{ dropdown: 'px-2 py-1 bg-gray-7 text-white' }}
      defaultOpened={defaultOpened}
      disabled={disabled}
      keepMounted={defaultOpened}
      position={position}
      withArrow={true}
      withinPortal={true}
    >
      <HoverCard.Target>
        <span style={{ display: 'inherit' }}>
          {customTarget ??
            (typeof materialIconProps !== 'undefined' ? (
              onClick ? (
                <PlainActionMaterialIcon iconName={materialIconProps.iconName} onClick={onClick} />
              ) : (
                <MaterialIcons {...materialIconProps} />
              )
            ) : (
              <MaterialIcons iconName="help" fill={true} className="cursor-help text-gray-6" />
            ))}
        </span>
      </HoverCard.Target>
      <HoverCard.Dropdown>
        <div className="max-w-xs text-2xs">{children}</div>
      </HoverCard.Dropdown>
    </HoverCard>
  );
};
